import styled from 'styled-components';

export const MinimumPriceListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 20px;
  flex-direction: row;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact};
  justify-content: space-between;

  @media (max-width: 1300px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  min-width: 200px;
  border-radius: 2px;
  border: solid 1px #e8eaeb;
`;

export const CurrencyCode = styled.div`
  min-width: 45px;
  min-height: 45px;
  border-radius: 2px;
  font-size: 14px;
  border: solid 1px #e8eaeb;
  background-color: rgba(232, 234, 235, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Value = styled.p`
  margin-left: 10px;
  font-size: 12px;
`;

export const MinimumPriceContainer = styled.div`
  margin-top: 20px;
  width: 100%;

  .pmcsButtons {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 20px;

    > * {
      margin-right: 10px;
    }
  }

  .modalContent > *:not(:last-child) {
    margin-bottom: 40px;
  }

  .ant-select .ant-select-arrow {
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  ${(props) =>
    props.hidden &&
    `display:flex; align-items:flex-end;justify-content:flex-end;`}
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 10px;
  width: ${(props) => 65 + props.length * 6}px;
  max-width: 200px;

  > p {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    margin-right: ${(props) => `calc(${50 - props.lengthCurrency * 4}px)`};
    font-size: 12px;
  }
`;

export const HideContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  text-decoration: underline;
  font-family: ${(props) => props.theme.fonts.sfcompact};
  color: ${(props) => props.theme.colors.dark};

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  p {
    margin-left: 10px;
  }
`;

export const HiddenContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  text-decoration: underline;
  font-family: ${(props) => props.theme.fonts.sfcompact};
  color: ${(props) => props.theme.colors.dark};

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  p {
    margin-left: 10px;
  }
`;
